import React, { FC } from 'react';
import { IonRouterOutlet } from '@ionic/react';

export interface AllieRouterOutletProps {
  children?: React.ReactNode;
  className?: string;
  id?: string;
  animated?: boolean;
  mode?: 'ios' | 'md';
}

/**
 * AllieRouterOutlet - Wrapper around IonRouterOutlet
 * Provides consistent router outlet behavior
 */
export const AllieRouterOutlet: FC<AllieRouterOutletProps> = ({
  children,
  className,
  id,
  animated = true,
  mode = 'md',
}) => {
  return (
    <IonRouterOutlet className={className} id={id} animated={animated} mode={mode}>
      {children}
    </IonRouterOutlet>
  );
};

AllieRouterOutlet.displayName = 'AllieRouterOutlet';
